import React from 'react';
import { Route } from 'react-router-dom';
import Autenticador from '../../servicios/Autenticador';
import servicioToken from '../../servicios/servicioToken';

const ProtectedRoute = ({path, component: Component, render, ...rest}) => {

    const token = servicioToken.obtenerToken();
    if(!token){
        Autenticador.AutenticarUsuario();
    }

    return ( 
        <Route
            {...rest}
            render={props => {
                return Component ? <Component {...props}/> : render(props);
            }}
        />
     );
}
 
export default ProtectedRoute;